import { useCallback, useEffect, useMemo } from "react";
import { useAppDispatch } from "../../hooks/storeHooks";
import { Asset, ItemAsset } from "../../types/asset";
import { updateImages } from "../../store/slices/inspectionSlice";
import {
    loadAssetImages,
    mapImageToItemAsset,
    filterImagesByToLoad
} from "../../utils/imageHelper";
import { CheckboxChangeEvent } from "primereact/checkbox";
import { ImagesGalleryItem } from "./ImageGalleryItem";
import "./ImageGallery.css";

type Props = {
    disabled: boolean;
    images: Asset[];
    selected: ItemAsset[];
    setSelected: (selected: ItemAsset[]) => void;
};

export const ImageGallery = (props: Props) => {
    const { disabled, images, selected, setSelected } = props;
    const dispatch = useAppDispatch();

    useEffect(() => {
        const fetchImages = async () => {
            const toLoad = filterImagesByToLoad(images);

            if (toLoad.length) {
                const response = await loadAssetImages(toLoad.slice(0, 24));

                dispatch(updateImages(response));
            }
        };

        fetchImages();
    }, [images]);

    const onCheck = useCallback(
        (image: Asset) => (event: CheckboxChangeEvent) => {
            if (event.checked) {
                setSelected(selected.concat([mapImageToItemAsset(image)]));
            } else {
                setSelected(
                    selected.filter((item) => item.Id !== image.asset_id)
                );
            }
        },
        [selected]
    );

    const renderImages = useMemo(
        () =>
            images.map((image) => {
                const checked = Boolean(
                    selected.find((item) => item.Id === image.asset_id)
                );

                return (
                    <ImagesGalleryItem
                        key={image.asset_id}
                        checked={checked}
                        disabled={disabled}
                        image={image}
                        onCheck={onCheck}
                    />
                );
            }),
        [images, selected]
    );

    return <div className="grid">{renderImages}</div>;
};
